<template>
    <div>
        <pleitos
            :pleitosServicos="obterDataServicos()"
            rotaDetalhar="Pleitos_Fornecedor_Detalhar"
            rotaListagem="Pleitos_Fornecedor"
            rotaInserir="Pleitos_Fornecedor_Inserir"
            rotaAtualizar="Pleitos_Fornecedor_Atualizar"
            :temAcessoDetalhar="$temAcessoView('PLEITOS-FORN-00')"
            :permiteInserir="$temAcessoView('PLEITOS-FORN-01')"
            :permiteAtualizar="$temAcessoView('PLEITOS-FORN-01')"
            :permiteExcluir="$temAcessoView('PLEITOS-FORN-02')"
            :permiteReenviarPleitoParaAnalise="$temAcessoView('PLEITOS-FORN-03')"
        ></pleitos>
        <router-view></router-view>
    </div>
</template>

<script>
import PleitosServicos from './PleitosServicos'
import Pleitos from '../componentes/PleitosLista'

export default {
    components: {
        Pleitos
    },

    methods: {
        obterDataServicos() {
            return PleitosServicos
        }
    },
}
</script>

